import api from "../lib/api";

export const initiatePhonePePayment = async (payload) => {
  const { data } = await api.post("/payments/phonepe/initiate", payload);
  return data;
};

export const verifyPhonePePayment = async (merchantTransactionId) => {
  const { data } = await api.get(`/payments/phonepe/status/${merchantTransactionId}`);
  return data;
};

// ponytail: [cynos-sociomanch payment bridge]
export const initiateBridgePayment = async (payload) => {
  const { data } = await api.post("/payments/bridge/initiate", payload);
  return data;
};
